import { MunicipalitiesApi } from 'api';
import { useEffect, useMemo, useState } from 'react';

const municipalitiesGlobal: { municipalities: { id: number; name: string }[]; loaded: boolean } = {
  municipalities: [],
  loaded: false,
};

const useMunicipalities = () => {
  const [municipalities, setMunicipalities] = useState<{ id: number; name: string }[]>(
    municipalitiesGlobal.municipalities,
  );
  const fetch = async () => {
    try {
      const result = await MunicipalitiesApi.getListOfMunicipalitets();
      municipalitiesGlobal.municipalities = result.map((el) => ({
        id: el.id,
        name: el.display_name,
      }));
    } catch (e) {}

    municipalitiesGlobal.loaded = true;
    setMunicipalities(municipalitiesGlobal.municipalities);
  };
  useEffect(() => {
    if (!municipalitiesGlobal.loaded) {
      fetch();
    }
  }, []);

  return useMemo(() => ({ municipalities, loaded: municipalitiesGlobal.loaded }), [municipalities]);
};

export default useMunicipalities;
